<template>
	<section class="QuickSearchLayout__container">
		<div class="condition-panel">
			<slot name="condition" />
		</div>

		<div class="list-panel">
			<slot name="list" />
		</div>

		<div class="pagination-panel">
			<slot name="pagination" />
		</div>
	</section>
</template>

<script>
	export default {};
</script>

<style lang="scss" scoped>
	.QuickSearchLayout__container {
		height: 100%;
		display: flex;
		flex-direction: column;

		.condition-panel {
			margin-bottom: 10px;
		}

		.list-panel {
			flex: 1;
			overflow: auto;
		}

		.pagination-panel {
			margin-top: 20px;
		}
	}
</style>
